import StickyTable from './stickyTable';

window.nn.registerModule('stickyTable', (tableElement, config) => {
  return new StickyTable(tableElement, config);
});